import React from 'react';

/*
  props:
  href={}
  handleClick={}
  text={}
  style={}
  className={}
  color (options: white)
*/

function getSrc(color) {
  if (color === 'white') {
    return 'https://cdn.shopify.com/s/files/1/1033/0751/files/SecondaryCTA_Arrow-Right_white.png?v=1582060962';
  }
  return 'https://cdn.shopify.com/s/files/1/1033/0751/files/SecondaryCTA_Arrow-Right_1.svg?235129';
}

const CtaSecondaryRight = (props) => {
  const isDownload = props.download ? true : false;
  const className = props.className ? props.className : '';
  return (
    <div className={`${className} cta-btn-container`} style={props.style}>
      <a
        href={`${props.href}`}
        className='cta-btn secondary'
        target={props.target}
        onClick={props.handleClick}
        download={isDownload}
      >
        {props.dangerouslySetInnerHTML ? (
          <span dangerouslySetInnerHTML={{ __html: props.dangerouslySetInnerHTML }}></span>
        ) : (
          props.text
        )}
      </a>
    </div>
  );
};

export default CtaSecondaryRight;
